import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const ScrewdriverRulerIcon = createIcon({
  displayName: 'ScrewdriverRulerIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <rect width="24" height="24" fill="none" />
      <path
        d="M10.5,10.5,3.62132,17.37866a2.12132,2.12132,0,0,0,0,3h0a2.12132,2.12132,0,0,0,3,0L13.5,13.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M19.62918,3.03274l-2.45239.81716a1,1,0,0,0-.68386.94869V6.5071a1,1,0,0,0,1,1h1.70958a1,1,0,0,0,.9488-.68418l.81605-2.45182a.5.5,0,0,0-.12076-.51134l-.70569-.70608A.5.5,0,0,0,19.62918,3.03274Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="11.99988"
        y1="11.99988"
        x2="16.78569"
        y2="7.21406"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="10"
        y1="10"
        x2="14"
        y2="14"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M6.24,10.76,3.3,7.82a1.026,1.026,0,0,1,0-1.45L6.37,3.3a1.026,1.026,0,0,1,1.45,0l4.44,4.44"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M16.26,11.74l4.44,4.44a1.026,1.026,0,0,1,0,1.45L17.63,20.7a1.026,1.026,0,0,1-1.45,0l-2.94-2.94"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const ScrewdriverRuler: FC<IconProps> = (props) => {
  return <CustomIcon as={ScrewdriverRulerIcon} {...props} />
}

export default memo(ScrewdriverRuler)
